import React from "react";
import "./education.css";

const Education =()=> {
    const institutes = [
      {
        nombre: "Colegio Universitario Francisco de Miranda",
        descripcion: "Carrera Universitaria en Tecnología",
        fecha: "Ingeniería en Informática | 2024 - En Curso",
      },
      {
        nombre: "Liceo Ávila.",
        descripcion: "Educación secundaria.",
        fecha: "Bachiller en Ciencias. | 2011 - 2017",
      },
    ];
  
    return (
      <section id="education" className="education">
        <h2>Educación</h2>
        <div className="projects-container-education">
          {institutes.map((project, index) => (
            <div key={index} className="project-card-education">
              <h3>{project.nombre}</h3>
              <p>{project.descripcion}</p>
              <p>{project.fecha}</p>
            </div>
          ))}
        </div>
      </section>
    );
  }

export default Education;